var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRectangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_rectangle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .rectangle-class-a {\n        fill: none !important;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    className: "rectangle-class-a",
    "data-name": "Rectangle 520",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M74.667,1638A1.668,1.668,0,0,0,73,1639.662v16.675A1.668,1.668,0,0,0,74.667,1658H91.333A1.668,1.668,0,0,0,93,1656.338v-16.675A1.668,1.668,0,0,0,91.333,1638Zm.833,1.662a.836.836,0,0,0-.833.838v15a.836.836,0,0,0,.833.838h15a.836.836,0,0,0,.833-.838v-15a.836.836,0,0,0-.833-.838Z",
    transform: "translate(-67 -1632)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRectangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_rectangle.d8da32905915a9549ff57e12fb2e1167.svg";